import { css } from '@emotion/react'
import styled from '@emotion/styled'
import { Text as BaseText, Button as BaseButton } from '@leroy-merlin-br/backyard-react-ui'

const wrapperStyles = ({ theme }) => css`
  label: wrapper;

  padding: 0 ${theme.spacings.giga};
  margin-bottom: ${theme.spacings.kilo};

  width: 100%;
  display: grid;
  grid-template-columns: 1fr;

  ${theme.media.giga} {
    grid-template-columns: 1fr 1fr;
    grid-column-gap: ${theme.spacings.giga};

    margin-bottom: 0;
  }
`

const titleStyles = ({ theme }) => css`
  label: wrapper__title;

  ${theme.media.kilo} {
    font-size: ${theme.typography.headings.giga.fontSize};
    line-height: ${theme.typography.headings.giga.lineHeight};
    font-weight: ${theme.font.weight.semibold};
  }

  margin-bottom: ${theme.spacings.kilo};

  color: ${theme.colors.v600};
`

const buttonStyles = ({ theme }) => css`
  label: wrapper__button;

  margin-top: ${theme.spacings.byte};
`

const imageStyles = ({ theme, url = '' }) => css`
  label: wrapper__image;

  min-height: 260px;
  border-radius: ${theme.borderRadius.giga};

  background-image: url(${url});
  background-position: 66%;
  background-repeat: no-repeat;
  background-size: cover;
`

export const Wrapper = styled('div')(wrapperStyles)
export const Title = styled(BaseText)(titleStyles)
export const Button = styled(BaseButton)(buttonStyles)
export const Image = styled('div')(imageStyles)
